const TrustScheme = {
  Dark: "#333",
  Light: "#e7e7e7",
  Primary: "#2473aa",
  Secondary: "#9a9a9a",
  Tertiary: "#5e3930",
};

export default TrustScheme;
